/**
 * Liczby części ścieżek certyfikacji dla UI szkoleń (formularz tworzenia/edycji).
 * Źródło: zmienne VUE_APP_* w .env frontu (wstrzykiwane przy buildzie).
 * Trzymaj je zgodne z CERTIFICATION_*_PARTS_COUNT w .env backendu.
 * Fallback 3 / 2 gdy brak lub niepoprawna wartość w env.
 */
function parsePositiveInt(raw, fallback) {
  const n = parseInt(String(raw), 10)
  return Number.isFinite(n) && n > 0 ? n : fallback
}

export function handlowiecCertificationPartsCount() {
  return parsePositiveInt(process.env.VUE_APP_CERTIFICATION_HANDLOWIEC_PARTS_COUNT, 3)
}

export function headOfSalesCertificationPartsCount() {
  return parsePositiveInt(process.env.VUE_APP_CERTIFICATION_HEAD_OF_SALES_PARTS_COUNT, 2)
}

export function maxCertificationPartsForKind(kind) {
  if (kind === 'HEAD_OF_SALES') {
    return headOfSalesCertificationPartsCount()
  }
  if (kind === 'HANDLOWIEC') {
    return handlowiecCertificationPartsCount()
  }
  return 0
}
